import { useState } from 'react';
import { useUpdateEffect } from '@qapline/helpers';

import { getTableStorageKey } from '../utils/tableStorage';

export const useStoredTableState = <T>(
    storageKeyPrefix: string,
    tableName: string | undefined,
    getStoredValue: (tableName?: string) => T,
) => {
    const [value, setValue] = useState<T>(() => getStoredValue(tableName));
    const storageKey = getTableStorageKey(storageKeyPrefix, tableName);

    useUpdateEffect(() => {
        if (storageKey) localStorage.setItem(storageKey, JSON.stringify(value));
    }, [storageKey, value]);

    return [value, setValue] as const;
};
